<template>
  <div>
    <header-component></header-component>
    <main>
      <section>
        <h1>保護者登録の流れ</h1>

  			<section>
          <h2 class="hide-heading">保護者登録について</h2>
          <div class="must-wrapper">
            <div class="must-inner">
              <div class="left">
                <div class="header">
                  訪問支援マッチングサービスアネラをご利用いただくには、<br class="br_sp">事前の保護者登録が必要です。
                </div>
                <div class="main">
                  <div class="text">
                    ご利用希望の方は、保護者登録ボタンより、必要事項をご入力ください。<br>
                    ご入力いただいた情報を事務局で確認させていただき、審査が完了したら、<br class="br_pc">ご登録いただいた電話番号あてに審査完了のご連絡をします。
                  </div>
                </div>
              </div>
              <div class="right">
                <p class="button"><router-link :to="{name: 'MembersRegister'}"><span class="inner">保護者登録はこちらから</span></router-link></p>
              </div>
            </div>
          </div>
  			</section>

  			<section>
					<h2 class="hide-heading">保護者登録の流れ</h2>
          <div class="steps-wrapper">
            <div class="steps-inner">
              <div class="step">
                <h3 class="header">保護者登録（所要時間1分）</h3>
                <div class="main">
                  登録フォームにメールアドレスとご希望のパスワード（任意）を入力してください。
                  <div class="img">
                    <img src="@/assets/image/members-registration-flow/registration_flow_image_01.jpg"  alt="登録イメージ">
                  </div>
                  <p>ご登録いただいたメールアドレス宛に、訪問支援マッチングサービスアネラから確認メールが届きますのでメールの指示に従い、次のステップにお進みください。</p>
                  <p>@omni-anela.comからメールを受信できるよう、迷惑メールの設定をご確認ください。</p>
                </div>
              </div>
              <div class="step">
                <h3 class="header">プロフィール入力（所要時間10分）</h3>
                <div class="main">
                  保護者情報や緊急連絡先、お子さんの健康情報をご入力いただきます。
                  <div class="img">
                    <img src="@/assets/image/members-registration-flow/registration_flow_image_02.jpg" alt="登録イメージ">
                  </div>
                  <p class="kome"><span class="need">本人確認用に運転免許証などの身分証明書とお子さまと保護者が一緒に写っている写真が必要</span>になります。<br>
                  あらかじめお手元ご準備いただくとスムーズに登録が完了します。<br>
                  プロフィールは正確に漏れがないようご記入いただきますようご協力ください。</p>
                </div>
              </div>
              <div class="step">
                <h3 class="header">審査</h3>
                <div class="main">
                  ご入力内容を事務局で確認させていただきます。入力の項目漏れがあった場合にはメールにてご連絡をいたします。<br>
                  審査が無事完了しましたら、ご登録いただいた番号あてに電話連絡をいたします。ご利用目的のヒアリング後、<br class="br_pc">ご利用時の注意事項を説明いたします。（所要時間3分）
                  <div class="img">
                    <img src="@/assets/image/members-registration-flow/registration_flow_image_03.jpg" alt="登録イメージ">
                  </div>
                  <p class="kome">訪問支援マッチングサービスアネラでは安心安全にサイトを利用してもらうためにサポーターについては面談での本人確認、保護者については電話での本人確認をおこなっております。<br>
                  あらかじめお手元ご準備いただくとスムーズに登録が完了します。<br>
                  プロフィールは正確に漏れがないようご記入いただきますようご協力ください。</p>
                  <p class="kome">審査完了までのお時間は、通常1～3営業日が目安となります。</p>
                </div>
              </div>
              <div class="disclaimer">
                <h3 class="header">ご留意事項</h3>
                <div class="main">
                  <p class="kome">保護者登録時に入力いただいたパスワードはサイトのログイン時にも利用いたしますので、大切に保管しておいてください。</p>
                  <p>ご入力内容を確認の上、利用の可否について判断を行います。審査によりご利用いただけない場合がございます。情報入力後、<br class="br_pc">数日以内に電話連絡がない場合は恐れ入りますが、052-971-7653までお問い合わせください。</p>
                </div>
              </div>
            </div>
          </div>
  			</section>
      </section>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "./HeaderComponent";
import FooterComponent from "./FooterComponent";

export default {
  metaInfo: {
    title: "保護者登録の流れ | 訪問支援マッチングサービスアネラ - 訪問支援マッチングサービスアネラは全国でご利用いただける障がい児向け訪問型療育サービスです。お気軽にお問い合わせください。"
  },
  components: {
    HeaderComponent,
    FooterComponent
  }
};
</script>
<style lang="scss" scoped>
.hide-heading{
  display: none;
}
.br_pc{
  display: none;
}
main {
  h1 {
    width: 100%;
    max-width: 1200px;
    margin: 20px auto;
    padding-left: 10px;
    box-sizing: border-box;
    line-height: 1.5em;
    font-size: 20px;
  }

  .must-wrapper {
    // background: #ffc;
    .must-inner {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding: 0.5em 0.5rem 1em;
      box-sizing: border-box;
      .left {
        .header {
          margin: auto;
          line-height: 1.5em;
          font-size: 14px;
          font-weight: bold;
        }
        .main {
          position: relative;
          margin-top: 10px;
          margin-bottom: 1em;
          .text {
            position: relative;
            z-index: 1;
            padding: 0.5em;
            background: white;
            line-height: 1.5em;
            font-size: 14px;
          }
        }
      }
      .right {
        margin: 0;
        .button {
          text-align: center;
          a {
            display: inline-block;
            padding: 0.25em;
            background-color: #7dc7ae;
            color: #fff;
            font-size: 14px;
            font-weight: bold;
            filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.3));
            transition: all .5s;
            .inner {
              display: block;
              padding: 0.25em 1em;
              border: 1px solid #fff;
              text-align: center;
              transition: all .5s;
            }
            &:hover{
              filter: none;
              & .inner{
                border: 1px solid rgba(255, 255, 255, 0);
              }
            }
          }
        }
      }
    }
  }
  .steps-wrapper {
    .steps-inner {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      .step {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        background: #eee;
        margin: 20px 10px;
        counter-increment: count;
        border-radius: 20px;
        filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.3));
          .header {
            margin: 0;
            font-size: 16px;
            font-weight: bold;
            text-align: left;
          }
          .header::before {
            content: counter(count) "　";
          }
          .main {
            margin-top: 12px;
            line-height: 1.5em;
            font-size: 14px;
            .img {
              width: 90%;
              max-width: 636px;
              margin: 20px auto;
              img {
                display: block;
                width: 90%;
                max-width: 636px;
                margin: auto;
              }
            }
            p {
              font-size: 12px;
              .need {
                color: #f28181;
              }
            }
            p.kome {
              margin-left: 1em;
            }
            P.kome::before {
              content: "※";
              margin-left: -1em;
            }
          }
      }
      .disclaimer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        margin: 20px 10px;
        counter-increment: count;
        border-radius: 20px;
          .header {
            margin: 0;
            font-size: 16px;
            font-weight: bold;
            text-align: left;
          }
          .main {
            margin-top: 12px;
            line-height: 1.5em;
            font-size: 14px;
            .img {
              width: 90%;
              max-width: 636px;
              margin: 20px auto;
              img {
                display: block;
                width: 90%;
                max-width: 636px;
                margin: auto;
              }
            }
            p {
              font-size: 12px;
              .need {
                color: #f28181;
              }
            }
            p.kome {
              margin-left: 1em;
            }
            P.kome::before {
              content: "※";
              margin-left: -1em;
            }
          }
      }

    }
  }
  @media (min-width: 768px) {
    .br_sp{
      display: none;
    }
    .br_pc{
      display: inline;
    }
    h1 {
      font-size: 32px;
    }
    .must-wrapper {
      .must-inner {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        padding: 0.5em 0.5rem 1em;
        .left {
          flex: 0 0 640px;
          .header {
            margin: auto;
            line-height: 1.5em;
            font-size: 20px;
          }
          .main {
            margin-top: 10px;
            margin-bottom: 1em;
            .text {
              padding: 0.5em 3em;
              line-height: 1.5em;
              font-size: 16px;
            }
          }
        }
        .right {
          flex: 1 1 376px;
          .button {
            a {
              padding: 0.75em 0.5em;
              font-size: 16px;
              .inner {
                font-size: 24px;
                padding: 0.75rem 3rem;
              }
            }
          }
        }
      }
    }
    .steps-wrapper {
      .steps-inner {
        .step {
          margin: 40px 10px;
          .header {
            font-size: 18px;
          }
          .main {
            font-size: 14px;
            p {
              font-size: 14px;
            }
          }
        }
        .disclaimer {
          margin: 40px 10px;
          .header {
            font-size: 18px;
          }
          .main {
            font-size: 14px;
            p {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MembersRegistrationFlow.vue